import { Box, Stack, Typography } from "@mui/material"

import useAppStore from "store/app"

import { EXPECTED_SYMPTOMS_COUNT } from "config/constants"

import AlertInfo from "./AlertInfo"
import SymptomsSearch from "components/shared/fields/SymptomsSearch"
import PrimaryButton from "components/shared/buttons/PrimaryButton"
import BottomDrawer from "../../BottomDrawer"
import Chips from "./Chips"
import BodySelector from "./BodySelector"

import GrayButton from "components/shared/buttons/GrayButton"
import SecondaryButton from "components/shared/buttons/SecondaryButton"
import { useEffect } from "react"
import useTranslation from "hooks/use_translation"

const Symptoms = () => {
  const nextStep = useAppStore((state) => state.nextAnamnesisStep)
  const prevStep = useAppStore((state) => state.prevAnamnesisStep)
  const finalStep = useAppStore((state) => state.finalStep)

  const getAnamnesis = useAppStore((state) => state.getAnamnesis)
  const getNextQuestion = useAppStore((state) => state.getNextQuestion)
  const handleSelect = useAppStore((state) => state.bodyPartSelect)

  const toggleDrawer = useAppStore((state) => state.toggleDrawer)
  const { symptoms } = useAppStore((state) => state.anamnesis)

  const { direction } = useAppStore((state) => state.meta)

  const { anamnesis } = useTranslation()

  const valid = symptoms.length >= EXPECTED_SYMPTOMS_COUNT

  useEffect(() => {
    getAnamnesis()
  }, [])

  const handleSubmit = () => {
    if (!valid) return

    getNextQuestion().then((exit_status) => {
      if (exit_status?.should_stop === true) {
        finalStep()
      } else {
        nextStep()
      }
    })
  }

  const handleSearch = () => {
    handleSelect(null)
    toggleDrawer(true)
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        {anamnesis?.symptoms_title}
      </Typography>

      <Typography sx={{ fontWeight: 500, mb: 3 }}>{anamnesis?.symptoms_subtitle}</Typography>

      {!valid && <AlertInfo />}

      <Chips />

      <PrimaryButton
        variant="outlined"
        fullWidth
        text={anamnesis?.symptoms_search}
        sx={{ mb: 1 }}
        onClick={handleSearch}
      />

      <Typography textAlign="center" sx={{ my: 1 }}>
        {anamnesis?.symptoms_or}
      </Typography>

      <Typography sx={{ mb: 1, fontWeight: 700, textAlign: "center" }}>
        {anamnesis?.symptoms_body}
      </Typography>

      <BodySelector />

      <Stack direction={direction === "rtl" ? "row-reverse" : "row"} columnGap={3} sx={{ mt: 4 }}>
        <GrayButton text={anamnesis?.back_btn} fullWidth onClick={prevStep} />

        <SecondaryButton
          text={anamnesis?.next_btn}
          fullWidth
          onClick={handleSubmit}
          disabled={!valid}
        />
      </Stack>

      <BottomDrawer>
        <SymptomsSearch />
      </BottomDrawer>
    </Box>
  )
}

export default Symptoms
